module.exports = __webpack_public_path__ + "img/FB_icon.35b082ee.svg";